import Header from "@/components/enfinity/case-studies/Header";
import CaseStudies from "@/components/enfinity/case-studies/CaseStudies";
import OurPartners from "@/components/enfinity/case-studies/OurPartners";
import CTA from "@/components/enfinity/CTA";
import Footer from "@/components/enfinity/Footer";
import { useEffect } from "react";

export default function EnfinityCaseStudiesEnfiniShield() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="bg-[#111111]">
      <Header />

      <CaseStudies />

      <OurPartners />

      <CTA />

      <Footer />
    </div>
  );
}
